import { baseApi } from "./baseApi";

const ACCOUNT_LIST_BASE_URL = "/account-list";

export const accountListSlice = baseApi.injectEndpoints({
  tagTypes: ["AccountList"],
  endpoints: (build) => ({
    addAccountListOption: build.mutation({
      query(body) {
        return {
          url: ACCOUNT_LIST_BASE_URL,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, err) => [{ type: "AccountList", id: "LIST" }],
    }),

    populateAccountList: build.mutation({
      query({ type, options }) {
        return {
          url: `${ACCOUNT_LIST_BASE_URL}/populate/${type}`,
          method: "POST",
          body: options,
        };
      },
      invalidatesTags: (result, err) => [{ type: "AccountList", id: "LIST" }],
    }),

    listAccountListOptions: build.query({
      query: (params) => {
        return {
          url: ACCOUNT_LIST_BASE_URL,
          params,
        };
      },
      providesTags: (result) =>
        result?.length
          ? [
              ...result.map(({ _id }) => ({ type: "AccountList", id: _id })),
              { type: "AccountList", id: "LIST" },
            ]
          : [{ type: "AccountList", id: "LIST" }],
    }),

    getAccountListDetail: build.query({
      query: (accountId) => {
        return {
          url: `${ACCOUNT_LIST_BASE_URL}/${accountId}`,
        };
      },
      providesTags: (result, error, { _id }) => [
        { type: "AccountList", _id },
        { type: "AccountList", id: "LIST" },
      ],
    }),

    updateAccountListOption: build.mutation({
      query: ({ _id, ...body }) => {
        return {
          url: `${ACCOUNT_LIST_BASE_URL}/${_id}`,
          body,
          method: "PUT",
        };
      },
      invalidatesTags: (result, err) => [{ type: "AccountList", id: "LIST" }],
    }),

    reOrderAccountListOptions: build.mutation({
      query(body) {
        return {
          url: `${ACCOUNT_LIST_BASE_URL}/reorder`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, err) => [{ type: "AccountList", id: "LIST" }],
    }),
  }),
});

export const {
  useAddAccountListOptionMutation,

  usePopulateAccountListMutation,

  useListAccountListOptionsQuery,
  useLazyListAccountListOptionsQuery,

  useGetAccountListDetailQuery,
  useLazyGetAccountListDetailQuery,

  useUpdateAccountListOptionMutation,

  useReOrderAccountListOptionsMutation,
} = accountListSlice;
